import moment from "moment";
import functionCommon from "../common/function";
import CONSTANT from "../constant/constant";
import { myLeaveRequestConstants } from "../constant/myLeaveRequest.constants";
import { myLeaveRequest } from "../services/myLeaveRequest.service";

const _errorCode = CONSTANT.errorCode;

export const getLeaveTypeList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        myLeaveRequest.listLeaveType(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;

                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(listLeaveType) {
        const listType = listLeaveType.listLeaveTypeSelectBox;
        return { type: myLeaveRequestConstants.GET_LEAVE_TYPE_SUCCESS, listType };
    }
};

export const getSummaryOfLeave = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        myLeaveRequest.summaryOfLeave(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;

                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(summaryOfLeave) {
        const listSummary = summaryOfLeave.mySummaryOfLeaveType;
        return { type: myLeaveRequestConstants.GET_SUMMARY_SUCCESS, listSummary };
    }
};

export const getListRequest = (data, isSearch = false, isPaging = false) => {
    const from = data.dayFrom.split("-").reverse().join("-");
    const to = data.dayTo.split("-").reverse().join("-");

    const params = {
        ...data,
        dayFrom: moment(from).format("YYYY-MM-DD"),
        dayTo: moment(to).format("YYYY-MM-DD"),
    };

    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        isSearch && dispatch(searching());
        isPaging && dispatch(paging());
        myLeaveRequest.listRequest(params).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;

                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(listRequest) {
        return { type: myLeaveRequestConstants.GET_REQUEST_LIST_SUCCESS, listRequest };
    }

    function searching() {
        return { type: myLeaveRequestConstants.GET_REQUEST_LIST };
    }

    function paging() {
        return { type: myLeaveRequestConstants.GET_REQUEST_LIST_PAGE };
    }
};

export const updateConfirm = () => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(updating());
        myLeaveRequest.updateIsConfirm().then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success());
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    dispatch(failure(res["error_code"]));
                    break;
            }
        });
    };

    function success() {
        return { type: myLeaveRequestConstants.UPDATE_CONFIRM_SUCCESS };
    }

    function updating() {
        return { type: myLeaveRequestConstants.UPDATE_CONFIRM };
    }

    function failure(error) {
        return { type: myLeaveRequestConstants.UPDATE_CONFIRM_FAIL, error };
    }
};

export const clearMessageModal = () => {
    return (dispatch) => {
        dispatch({ type: myLeaveRequestConstants.CLEAR_MESSAGE });
    };
};
